"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = require("prop-types");

var _CardHeader = _interopRequireDefault(require("./CardHeader"));

var _CardContent = _interopRequireDefault(require("./CardContent"));

var _CardFooter = _interopRequireDefault(require("./CardFooter"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var Card = function Card(_ref) {
  var children = _ref.children,
      onClick = _ref.onClick,
      className = _ref.className,
      otherProps = _objectWithoutProperties(_ref, ["children", "onClick", "className"]);

  return /*#__PURE__*/_react.default.createElement(StyledCard, _extends({
    onClick: onClick,
    className: className
  }, otherProps), children);
};

var StyledCard = _styledComponents.default.div.withConfig({
  displayName: "StyledCard"
})(["width:100%;font-family:", ";max-width:100rem;background-color:white;border:2px solid #f0f1f3;box-shadow:0 0 1px rgba(0,0,0,0.04),0 0 2px rgba(0,0,0,0.06),0 4px 8px rgba(0,0,0,0.04);border-radius:0.5rem;transition:box-shadow 0.1s ease-in-out,border 0.1s ease-in-out;cursor:", ";&:hover{border:", ";box-shadow:", ";}"], function (_ref2) {
  var theme = _ref2.theme;
  return theme.font;
}, function (_ref3) {
  var onClick = _ref3.onClick;
  return onClick ? 'pointer' : 'default';
}, function (_ref4) {
  var theme = _ref4.theme,
      onClick = _ref4.onClick;
  return onClick ? "2px solid ".concat(theme.brand.primary) : null;
}, function (_ref5) {
  var onClick = _ref5.onClick;
  return onClick ? '0px 0px 1px rgba(0, 0, 0, 0.04), 0px 4px 8px rgba(0, 0, 0, 0.04), 0px 16px 24px rgba(0, 0, 0, 0.04), 0px 24px 32px rgba(0, 0, 0, 0.04)' : null;
});

Card.propTypes = {
  children: _propTypes.node.isRequired,
  onClick: _propTypes.func,
  className: _propTypes.string,
  otherProps: _propTypes.object
};
Card.CardHeader = _CardHeader.default;
Card.CardHeader.displayName = 'Card.CardHeader';
Card.CardContent = _CardContent.default;
Card.CardContent.displayName = 'Card.CardContent';
Card.CardFooter = _CardFooter.default;
Card.CardFooter.displayName = 'Card.CardFooter';
var _default = Card;
exports.default = _default;